type Props = {
  id?: string;
  name?: string;
  type: string;
  placeholder: string;
  onChange: (e: any) => void;
  value?: string;
  checked?: any;
};
const CustomInput = (props: Props) => {
  return (
    <input
      {...props}
      className="text-md hover:ring-2 block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
    />
  );
};

export default CustomInput;
